webpackJsonp([20],{

/***/ 949:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	
	var _typeofReactElement = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 60103;
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _defaultProps(defaultProps, props) { if (defaultProps) { for (var propName in defaultProps) { if (typeof props[propName] === 'undefined') { props[propName] = defaultProps[propName]; } } } return props; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(52);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _componentsCard = __webpack_require__(94);
	
	var _componentsCard2 = _interopRequireDefault(_componentsCard);
	
	var _ReviewListScss = __webpack_require__(950);
	
	var _ReviewListScss2 = _interopRequireDefault(_ReviewListScss);
	
	var _ReviewForm = __webpack_require__(953);
	
	var _ReviewForm2 = _interopRequireDefault(_ReviewForm);
	
	var _componentsReview = __webpack_require__(957);
	
	var _componentsReview2 = _interopRequireDefault(_componentsReview);
	
	var _componentsBigNumber = __webpack_require__(961);
	
	var _componentsBigNumber2 = _interopRequireDefault(_componentsBigNumber);
	
	var _utilsLang = __webpack_require__(205);
	
	var _decoratorsConnectToStores = __webpack_require__(161);
	
	var _decoratorsConnectToStores2 = _interopRequireDefault(_decoratorsConnectToStores);
	
	var _decoratorsWithStyles = __webpack_require__(67);
	
	var _decoratorsWithStyles2 = _interopRequireDefault(_decoratorsWithStyles);
	
	var ReviewList = (function (_React$Component) {
		_inherits(ReviewList, _React$Component);
	
		function ReviewList() {
			_classCallCheck(this, _ReviewList);
	
			_get(Object.getPrototypeOf(_ReviewList.prototype), 'constructor', this).apply(this, arguments);
		}
	
		_createClass(ReviewList, [{
			key: 'render',
			value: function render() {
				var _props = this.props;
				var newReview = _props.newReview;
				var flux = _props.flux;
				var formSending = _props.formSending;
				var reviews = _props.reviews;
				var showReviewForm = _props.showReviewForm;
				var coachId = _props.coachId;
				var programId = _props.programId;
				var rating = _props.rating;
				var added = _props.added;
	
				var reviewActions = flux.getActions('review');
	
				return {
					$$typeof: _typeofReactElement,
					type: _componentsCard2['default'],
					key: null,
					ref: null,
					props: _defaultProps(_componentsCard2['default'].defaultProps, {
						children: [{
							$$typeof: _typeofReactElement,
							type: 'div',
							key: null,
							ref: null,
							props: {
								children: [{
									$$typeof: _typeofReactElement,
									type: _componentsBigNumber2['default'],
									key: null,
									ref: null,
									props: _defaultProps(_componentsBigNumber2['default'].defaultProps, {
										number: Number(rating.rating),
										label: "рейтинг",
										className: (0, _ReviewListScss2['default'])('number')
									}),
									_owner: null
								}, {
									$$typeof: _typeofReactElement,
									type: _componentsBigNumber2['default'],
									key: null,
									ref: null,
									props: _defaultProps(_componentsBigNumber2['default'].defaultProps, {
										number: Number(rating.count),
										label: (0, _utilsLang.declension)("оценка|оценки|оценок", rating.count),
										className: (0, _ReviewListScss2['default'])('number')
									}),
									_owner: null
								}],
								className: (0, _ReviewListScss2['default'])('stat')
							},
							_owner: null
						}, {
							$$typeof: _typeofReactElement,
							type: 'h2',
							key: null,
							ref: null,
							props: {
								children: "Відгуки",
								className: (0, _ReviewListScss2['default'])('title')
							},
							_owner: null
						}, showReviewForm && !added && {
							$$typeof: _typeofReactElement,
							type: 'div',
							key: null,
							ref: null,
							props: {
								children: {
									$$typeof: _typeofReactElement,
									type: _ReviewForm2['default'],
									key: null,
									ref: null,
									props: _defaultProps(_ReviewForm2['default'].defaultProps, {
										review: newReview,
										onChange: function (review) {
											return reviewActions.formUpdate(review);
										},
										onSubmit: function () {
											return reviewActions.createReview(newReview, coachId, programId);
										},
										sending: formSending
									}),
									_owner: null
								},
								className: (0, _ReviewListScss2['default'])('form')
							},
							_owner: null
						}, {
							$$typeof: _typeofReactElement,
							type: 'div',
							key: null,
							ref: null,
							props: {
								children: reviews.map(function (review) {
									return {
										$$typeof: _typeofReactElement,
										type: 'div',
										key: review.get('id'),
										ref: null,
										props: {
											children: {
												$$typeof: _typeofReactElement,
												type: _componentsReview2['default'],
												key: null,
												ref: null,
												props: _defaultProps(_componentsReview2['default'].defaultProps, {
													review: review
												}),
												_owner: null
											},
											className: (0, _ReviewListScss2['default'])('item')
										},
										_owner: null
									};
								}),
								className: (0, _ReviewListScss2['default'])('list')
							},
							_owner: null
						}]
					}),
					_owner: null
				};
			}
		}], [{
			key: 'propTypes',
			value: {
				showReviewForm: _react.PropTypes.bool.isRequired,
				programId: _react.PropTypes.number.isRequired,
				coachId: _react.PropTypes.number.isRequired,
				flux: _react.PropTypes.object,
				newReview: _react.PropTypes.object,
				formSending: _react.PropTypes.bool,
				rating: _react.PropTypes.object,
				reviews: _react.PropTypes.object,
				added: _react.PropTypes.bool
			},
			enumerable: true
		}]);
	
		var _ReviewList = ReviewList;
		ReviewList = (0, _decoratorsConnectToStores2['default'])({
			reviewForm: function reviewForm(_ref) {
				var state = _ref.state;
				return {
					newReview: state.review,
					added: state.added,
					formSending: state.sending
				};
			},
			review: function review(_ref2) {
				var state = _ref2.state;
				return {
					reviews: state.reviews
				};
			},
			ratings: function ratings(_ref3, props) {
				var state = _ref3.state;
				return {
					rating: state.ratings[props.coachId]
				};
			}
		})(ReviewList) || ReviewList;
		ReviewList = (0, _decoratorsWithStyles2['default'])(_ReviewListScss2['default'])(ReviewList) || ReviewList;
		return ReviewList;
	})(_react2['default'].Component);
	
	exports['default'] = ReviewList;
	module.exports = exports['default'];

/***/ }),

/***/ 950:
/***/ (function(module, exports, __webpack_require__) {

	// bem-module-loader
	// wrap css module in func that generates className
	var content = __webpack_require__(951);
	if(typeof content === 'string') content = [[module.id, content, '']];
	var b_ = __webpack_require__(54);
	var realContent = (typeof content.locals === 'object') ? content.locals : content
	function bemModule() {
	return b_.apply(null, Array.prototype.slice.call(arguments)).split(' ').map(function(c) { return realContent[c];}).join(' ');
	}
	bemModule.content = content;
	module.exports = bemModule;

/***/ }),

/***/ 951:
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(952);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(66)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js?minimize&modules&importLoaders=1&localIdentName=[hash:base64:10]!../../../../node_modules/postcss-loader/index.js!../../../../node_modules/sass-loader/index.js?includePaths[]=%2Fvar%2Fwww%2Fyii%2Fprod.smartprogress%2Fsrc%2Fsass!./ReviewList.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js?minimize&modules&importLoaders=1&localIdentName=[hash:base64:10]!../../../../node_modules/postcss-loader/index.js!../../../../node_modules/sass-loader/index.js?includePaths[]=%2Fvar%2Fwww%2Fyii%2Fprod.smartprogress%2Fsrc%2Fsass!./ReviewList.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),

/***/ 952:
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(65)();
	// imports
	
	
	// module
	exports.push([module.id, ".EYUqcjRCy0{padding:15px;text-align:center;background-color:#ffcc4d}._1lYOXUAVJl{font-size:30px;font-weight:700;padding:30px 0 20px;text-transform:uppercase;text-align:center}@media (max-width:850px){._1lYOXUAVJl{font-size:20px;padding:10px}}._3pa09nj7jT{padding:0 60px 20px}@media (max-width:850px){._3pa09nj7jT{padding:0 10px 10px}}._2kytZJapMN{padding:20px 60px 30px;border-top:1px solid #f0f0f0}@media (max-width:850px){._2kytZJapMN{padding:10px}}._1xtiDEKnAq+._1xtiDEKnAq{margin-left:15%}", ""]);
	
	// exports
	exports.locals = {
		"stat": "EYUqcjRCy0",
		"title": "_1lYOXUAVJl",
		"form": "_3pa09nj7jT",
		"item": "_2kytZJapMN",
		"number": "_1xtiDEKnAq"
	};

/***/ }),

/***/ 953:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _typeofReactElement = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 60103;
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _defaultProps(defaultProps, props) { if (defaultProps) { for (var propName in defaultProps) { if (typeof props[propName] === 'undefined') { props[propName] = defaultProps[propName]; } } } return props; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(52);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _componentsFormRow = __webpack_require__(122);
	
	var _componentsFormRow2 = _interopRequireDefault(_componentsFormRow);
	
	var _componentsTextField = __webpack_require__(117);
	
	var _componentsTextField2 = _interopRequireDefault(_componentsTextField);
	
	var _componentsButton = __webpack_require__(93);
	
	var _componentsButton2 = _interopRequireDefault(_componentsButton);
	
	var _componentsStarRating = __webpack_require__(219);
	
	var _componentsStarRating2 = _interopRequireDefault(_componentsStarRating);
	
	var _ReviewFormScss = __webpack_require__(954);
	
	var _ReviewFormScss2 = _interopRequireDefault(_ReviewFormScss);
	
	var _decoratorsWithStyles = __webpack_require__(67);
	
	var _decoratorsWithStyles2 = _interopRequireDefault(_decoratorsWithStyles);
	
	var ReviewForm = (function (_React$Component) {
	  _inherits(ReviewForm, _React$Component);
	
	  function ReviewForm() {
	    _classCallCheck(this, _ReviewForm);
	
	    _get(Object.getPrototypeOf(_ReviewForm.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(ReviewForm, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var review = _props.review;
	      var onChange = _props.onChange;
	      var onSubmit = _props.onSubmit;
	      var _props$sending = _props.sending;
	      var sending = _props$sending === undefined ? false : _props$sending;
	
	      var filled = review.get('rating') && review.get('text', '').trim().length > 0;
	
	      return {
	        $$typeof: _typeofReactElement,
	        type: 'div',
	        key: null,
	        ref: null,
	        props: {
	          children: [{
	            $$typeof: _typeofReactElement,
	            type: _componentsFormRow2['default'],
	            key: null,
	            ref: null,
	            props: _defaultProps(_componentsFormRow2['default'].defaultProps, {
	              children: [{
	                $$typeof: _typeofReactElement,
	                type: 'h3',
	                key: null,
	                ref: null,
	                props: {
	                  children: "Оцініть якість роботи наставника",
	                  className: (0, _ReviewFormScss2['default'])('title')
	                },
	                _owner: null
	              }, {
	                $$typeof: _typeofReactElement,
	                type: _componentsStarRating2['default'],
	                key: null,
	                ref: null,
	                props: _defaultProps(_componentsStarRating2['default'].defaultProps, {
	                  value: review.get('rating'),
	                  size: 'm',
	                  onChange: function (rating) {
	                    return onChange(review.set('rating', rating));
	                  }
	                }),
	                _owner: null
	              }]
	            }),
	            _owner: null
	          }, {
	            $$typeof: _typeofReactElement,
	            type: _componentsFormRow2['default'],
	            key: null,
	            ref: null,
	            props: _defaultProps(_componentsFormRow2['default'].defaultProps, {
	              children: {
	                $$typeof: _typeofReactElement,
	                type: _componentsTextField2['default'],
	                key: null,
	                ref: null,
	                props: _defaultProps(_componentsTextField2['default'].defaultProps, {
	                  value: review.get('text'),
	                  onChange: function (text) {
	                    return onChange(review.set('text', text));
	                  }
	                }),
	                _owner: null
	              }
	            }),
	            _owner: null
	          }, {
	            $$typeof: _typeofReactElement,
	            type: _componentsFormRow2['default'],
	            key: null,
	            ref: null,
	            props: _defaultProps(_componentsFormRow2['default'].defaultProps, {
	              children: {
	                $$typeof: _typeofReactElement,
	                type: _componentsButton2['default'],
	                key: null,
	                ref: null,
	                props: _defaultProps(_componentsButton2['default'].defaultProps, {
	                  children: "Відправити",
	                  onClick: onSubmit,
	                  process: sending,
	                  disabled: !filled
	                }),
	                _owner: null
	              }
	            }),
	            _owner: null
	          }],
	          className: (0, _ReviewFormScss2['default'])('main')
	        },
	        _owner: null
	      };
	    }
	  }], [{
	    key: 'propTypes',
	    value: {
	      review: _react.PropTypes.object.isRequired,
	      onChange: _react.PropTypes.func,
	      onSubmit: _react.PropTypes.func,
	      sending: _react.PropTypes.bool
	    },
	    enumerable: true
	  }]);
	
	  var _ReviewForm = ReviewForm;
	  ReviewForm = (0, _decoratorsWithStyles2['default'])(_ReviewFormScss2['default'])(ReviewForm) || ReviewForm;
	  return ReviewForm;
	})(_react2['default'].Component);
	
	exports['default'] = ReviewForm;
	module.exports = exports['default'];

/***/ }),

/***/ 954:
/***/ (function(module, exports, __webpack_require__) {

	// bem-module-loader
	// wrap css module in func that generates className
	var content = __webpack_require__(955);
	if(typeof content === 'string') content = [[module.id, content, '']];
	var b_ = __webpack_require__(54);
	var realContent = (typeof content.locals === 'object') ? content.locals : content
	function bemModule() {
	return b_.apply(null, Array.prototype.slice.call(arguments)).split(' ').map(function(c) { return realContent[c];}).join(' ');
	}
	bemModule.content = content;
	module.exports = bemModule;

/***/ }),

/***/ 955:
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(956);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(66)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js?minimize&modules&importLoaders=1&localIdentName=[hash:base64:10]!../../../../node_modules/postcss-loader/index.js!../../../../node_modules/sass-loader/index.js?includePaths[]=%2Fvar%2Fwww%2Fyii%2Fprod.smartprogress%2Fsrc%2Fsass!./ReviewForm.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js?minimize&modules&importLoaders=1&localIdentName=[hash:base64:10]!../../../../node_modules/postcss-loader/index.js!../../../../node_modules/sass-loader/index.js?includePaths[]=%2Fvar%2Fwww%2Fyii%2Fprod.smartprogress%2Fsrc%2Fsass!./ReviewForm.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),

/***/ 956:
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(65)();
	// imports
	
	
	// module
	exports.push([module.id, "._3LIogh8k0t{font-size:22px;font-weight:700;margin-bottom:10px}", ""]);
	
	// exports
	exports.locals = {
		"title": "_3LIogh8k0t"
	};

/***/ }),

/***/ 957:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _typeofReactElement = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 60103;
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _defaultProps(defaultProps, props) { if (defaultProps) { for (var propName in defaultProps) { if (typeof props[propName] === 'undefined') { props[propName] = defaultProps[propName]; } } } return props; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(52);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _immutable = __webpack_require__(84);
	
	var _moment = __webpack_require__(103);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _ReviewScss = __webpack_require__(958);
	
	var _ReviewScss2 = _interopRequireDefault(_ReviewScss);
	
	var _componentsAvatar = __webpack_require__(89);
	
	var _componentsAvatar2 = _interopRequireDefault(_componentsAvatar);
	
	var _componentsFormattedContent = __webpack_require__(112);
	
	var _componentsFormattedContent2 = _interopRequireDefault(_componentsFormattedContent);
	
	var _componentsStarRating = __webpack_require__(219);
	
	var _componentsStarRating2 = _interopRequireDefault(_componentsStarRating);
	
	var _componentsUserBadge = __webpack_require__(142);
	
	var _componentsUserBadge2 = _interopRequireDefault(_componentsUserBadge);
	
	var _decoratorsWithStyles = __webpack_require__(67);
	
	var _decoratorsWithStyles2 = _interopRequireDefault(_decoratorsWithStyles);
	
	var Review = (function (_React$Component) {
	  _inherits(Review, _React$Component);
	
	  function Review() {
	    _classCallCheck(this, _Review);
	
	    _get(Object.getPrototypeOf(_Review.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(Review, [{
	    key: 'render',
	    value: function render() {
	      var compact = this.props.compact;
	
	      return compact ? this.renderCompact() : this.renderFull();
	    }
	  }, {
	    key: 'renderCompact',
	    value: function renderCompact() {
	      var review = this.props.review;
	
	      return {
	        $$typeof: _typeofReactElement,
	        type: 'div',
	        key: null,
	        ref: null,
	        props: {
	          children: [{
	            $$typeof: _typeofReactElement,
	            type: 'header',
	            key: null,
	            ref: null,
	            props: {
	              children: {
	                $$typeof: _typeofReactElement,
	                type: _componentsUserBadge2['default'],
	                key: null,
	                ref: null,
	                props: _defaultProps(_componentsUserBadge2['default'].defaultProps, {
	                  user: (0, _immutable.Map)({
	                    id: review.get('user_id'),
	                    username: review.get('username'),
	                    avatar: review.get('avatar')
	                  })
	                }),
	                _owner: null
	              },
	              className: (0, _ReviewScss2['default'])('header')
	            },
	            _owner: null
	          }, {
	            $$typeof: _typeofReactElement,
	            type: _componentsFormattedContent2['default'],
	            key: null,
	            ref: null,
	            props: _defaultProps(_componentsFormattedContent2['default'].defaultProps, {
	              children: '<p>' + review.get('text') + '</p>'
	            }),
	            _owner: null
	          }, {
	            $$typeof: _typeofReactElement,
	            type: 'footer',
	            key: null,
	            ref: null,
	            props: {
	              children: [{
	                $$typeof: _typeofReactElement,
	                type: _componentsStarRating2['default'],
	                key: null,
	                ref: null,
	                props: _defaultProps(_componentsStarRating2['default'].defaultProps, {
	                  value: review.get('rating')
	                }),
	                _owner: null
	              }, {
	                $$typeof: _typeofReactElement,
	                type: 'span',
	                key: null,
	                ref: null,
	                props: {
	                  children: ['Оценка ', review.get('rating'), '/5'],
	                  className: (0, _ReviewScss2['default'])('ratingText')
	                },
	                _owner: null
	              }],
	              className: (0, _ReviewScss2['default'])('footer')
	            },
	            _owner: null
	          }]
	        },
	        _owner: null
	      };
	    }
	  }, {
	    key: 'renderFull',
	    value: function renderFull() {
	      var review = this.props.review;
	
	      return {
	        $$typeof: _typeofReactElement,
	        type: 'div',
	        key: null,
	        ref: null,
	        props: {
	          children: [{
	            $$typeof: _typeofReactElement,
	            type: 'div',
	            key: null,
	            ref: null,
	            props: {
	              children: {
	                $$typeof: _typeofReactElement,
	                type: 'a',
	                key: null,
	                ref: null,
	                props: {
	                  children: {
	                    $$typeof: _typeofReactElement,
	                    type: _componentsAvatar2['default'],
	                    key: null,
	                    ref: null,
	                    props: _defaultProps(_componentsAvatar2['default'].defaultProps, {
	                      size: 'm',
	                      user_id: review.get('user_id'),
	                      avatar: review.get('avatar')
	                    }),
	                    _owner: null
	                  },
	                  href: '/user/' + review.get('user_id')
	                },
	                _owner: null
	              },
	              className: (0, _ReviewScss2['default'])('avatar')
	            },
	            _owner: null
	          }, {
	            $$typeof: _typeofReactElement,
	            type: 'div',
	            key: null,
	            ref: null,
	            props: {
	              children: [{
	                $$typeof: _typeofReactElement,
	                type: 'header',
	                key: null,
	                ref: null,
	                props: {
	                  children: [{
	                    $$typeof: _typeofReactElement,
	                    type: 'a',
	                    key: null,
	                    ref: null,
	                    props: {
	                      children: review.get('username'),
	                      href: '/user/' + review.get('user_id'),
	                      className: (0, _ReviewScss2['default'])('username')
	                    },
	                    _owner: null
	                  }, {
	                    $$typeof: _typeofReactElement,
	                    type: 'span',
	                    key: null,
	                    ref: null,
	                    props: {
	                      children: (0, _moment2['default'])(review.get('date')).calendar(),
	                      className: (0, _ReviewScss2['default'])('ts')
	                    },
	                    _owner: null
	                  }, {
	                    $$typeof: _typeofReactElement,
	                    type: 'p',
	                    key: null,
	                    ref: null,
	                    props: {
	                      children: ['Отзыв к программе «', review.get('program_name'), '»'],
	                      className: (0, _ReviewScss2['default'])('program')
	                    },
	                    _owner: null
	                  }],
	                  className: (0, _ReviewScss2['default'])('header')
	                },
	                _owner: null
	              }, {
	                $$typeof: _typeofReactElement,
	                type: _componentsFormattedContent2['default'],
	                key: null,
	                ref: null,
	                props: _defaultProps(_componentsFormattedContent2['default'].defaultProps, {
	                  children: '<p>' + review.get('text') + '</p>'
	                }),
	                _owner: null
	              }, {
	                $$typeof: _typeofReactElement,
	                type: 'footer',
	                key: null,
	                ref: null,
	                props: {
	                  children: [{
	                    $$typeof: _typeofReactElement,
	                    type: _componentsStarRating2['default'],
	                    key: null,
	                    ref: null,
	                    props: _defaultProps(_componentsStarRating2['default'].defaultProps, {
	                      value: review.get('rating')
	                    }),
	                    _owner: null
	                  }, {
	                    $$typeof: _typeofReactElement,
	                    type: 'span',
	                    key: null,
	                    ref: null,
	                    props: {
	                      children: ['Оценка ', review.get('rating'), '/5'],
	                      className: (0, _ReviewScss2['default'])('ratingText')
	                    },
	                    _owner: null
	                  }],
	                  className: (0, _ReviewScss2['default'])('footer')
	                },
	                _owner: null
	              }],
	              className: (0, _ReviewScss2['default'])('body')
	            },
	            _owner: null
	          }],
	          className: (0, _ReviewScss2['default'])('main')
	        },
	        _owner: null
	      };
	    }
	  }], [{
	    key: 'propTypes',
	    value: {
	      review: _react.PropTypes.object.isRequired,
	      compact: _react.PropTypes.bool.isRequired
	    },
	    enumerable: true
	  }, {
	    key: 'defaultProps',
	    value: {
	      compact: false
	    },
	    enumerable: true
	  }]);
	
	  var _Review = Review;
	  Review = (0, _decoratorsWithStyles2['default'])(_ReviewScss2['default'])(Review) || Review;
	  return Review;
	})(_react2['default'].Component);
	
	exports['default'] = Review;
	module.exports = exports['default'];

/***/ }),

/***/ 958:
/***/ (function(module, exports, __webpack_require__) {

	// bem-module-loader
	// wrap css module in func that generates className
	var content = __webpack_require__(959);
	if(typeof content === 'string') content = [[module.id, content, '']];
	var b_ = __webpack_require__(54);
	var realContent = (typeof content.locals === 'object') ? content.locals : content
	function bemModule() {
	return b_.apply(null, Array.prototype.slice.call(arguments)).split(' ').map(function(c) { return realContent[c];}).join(' ');
	}
	bemModule.content = content;
	module.exports = bemModule;

/***/ }),

/***/ 959:
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(960);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(66)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js?minimize&modules&importLoaders=1&localIdentName=[hash:base64:10]!../../../../node_modules/postcss-loader/index.js!../../../../node_modules/sass-loader/index.js?includePaths[]=%2Fvar%2Fwww%2Fyii%2Fprod.smartprogress%2Fsrc%2Fsass!./Review.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js?minimize&modules&importLoaders=1&localIdentName=[hash:base64:10]!../../../../node_modules/postcss-loader/index.js!../../../../node_modules/sass-loader/index.js?includePaths[]=%2Fvar%2Fwww%2Fyii%2Fprod.smartprogress%2Fsrc%2Fsass!./Review.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),

/***/ 960:
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(65)();
	// imports
	
	
	// module
	exports.push([module.id, "._1QvIBaxI0h{display:-ms-flexbox;display:flex;font-size:14px}._3hgqMfJ1pB{font-weight:700;text-decoration:none;color:inherit}._3hgqMfJ1pB:hover{color:#2ab8d5}.g75yLMtYaV{margin-right:15px}._2tSRikxEF4{width:100%}.RbT9Lwdoec{font-size:14px;color:#8c96a5}._1QM0T8_oKN,._2_K8Ub9KL2{font-size:9pt;color:#8c96a5}._1QM0T8_oKN:before{content:\" | \"}._2_K8Ub9KL2{display:inline-block;vertical-align:middle;margin-left:10px}._396MWsiZma{margin-bottom:5px}._1Wil9y15Uo{margin-top:5px}", ""]);
	
	// exports
	exports.locals = {
		"main": "_1QvIBaxI0h",
		"header": "_396MWsiZma",
		"username": "_3hgqMfJ1pB",
		"avatar": "g75yLMtYaV",
		"body": "_2tSRikxEF4",
		"program": "RbT9Lwdoec",
		"ts": "_1QM0T8_oKN",
		"ratingText": "_2_K8Ub9KL2",
		"footer": "_1Wil9y15Uo"
	};

/***/ }),

/***/ 961:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _typeofReactElement = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 60103;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(52);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _BigNumberScss = __webpack_require__(962);
	
	var _BigNumberScss2 = _interopRequireDefault(_BigNumberScss);
	
	var _numberFormat = __webpack_require__(965);
	
	var _decoratorsWithStyles = __webpack_require__(67);
	
	var _decoratorsWithStyles2 = _interopRequireDefault(_decoratorsWithStyles);
	
	function BigNumber(_ref) {
	  var number = _ref.number;
	  var label = _ref.label;
	  var _ref$className = _ref.className;
	  var className = _ref$className === undefined ? '' : _ref$className;
	
	  return {
	    $$typeof: _typeofReactElement,
	    type: 'div',
	    key: null,
	    ref: null,
	    props: {
	      children: [{
	        $$typeof: _typeofReactElement,
	        type: 'p',
	        key: null,
	        ref: null,
	        props: {
	          children: (0, _numberFormat.numberFormat)(number, 0, ',', ' '),
	          className: (0, _BigNumberScss2['default'])('number')
	        },
	        _owner: null
	      }, {
	        $$typeof: _typeofReactElement,
	        type: 'p',
	        key: null,
	        ref: null,
	        props: {
	          children: label,
	          className: (0, _BigNumberScss2['default'])('label')
	        },
	        _owner: null
	      }],
	      className: className + ' ' + (0, _BigNumberScss2['default'])('main')
	    },
	    _owner: null
	  };
	}
	
	exports['default'] = (0, _decoratorsWithStyles2['default'])(_BigNumberScss2['default'])(BigNumber);
	module.exports = exports['default'];

/***/ }),

/***/ 962:
/***/ (function(module, exports, __webpack_require__) {

	// bem-module-loader
	// wrap css module in func that generates className
	var content = __webpack_require__(963);
	if(typeof content === 'string') content = [[module.id, content, '']];
	var b_ = __webpack_require__(54);
	var realContent = (typeof content.locals === 'object') ? content.locals : content
	function bemModule() {
	return b_.apply(null, Array.prototype.slice.call(arguments)).split(' ').map(function(c) { return realContent[c];}).join(' ');
	}
	bemModule.content = content;
	module.exports = bemModule;

/***/ }),

/***/ 963:
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(964);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(66)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js?minimize&modules&importLoaders=1&localIdentName=[hash:base64:10]!../../../../node_modules/postcss-loader/index.js!../../../../node_modules/sass-loader/index.js?includePaths[]=%2Fvar%2Fwww%2Fyii%2Fprod.smartprogress%2Fsrc%2Fsass!./BigNumber.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js?minimize&modules&importLoaders=1&localIdentName=[hash:base64:10]!../../../../node_modules/postcss-loader/index.js!../../../../node_modules/sass-loader/index.js?includePaths[]=%2Fvar%2Fwww%2Fyii%2Fprod.smartprogress%2Fsrc%2Fsass!./BigNumber.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),

/***/ 964:
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(65)();
	// imports
	
	
	// module
	exports.push([module.id, "._1CGHrDMZ0u{display:inline-block;vertical-align:middle}._30t7gr97gF{font-family:museo_sans_cyrl900,PT Sans,Helvetica,Arial,sans-serif;font-size:36px}._1sbH9SaSiG{font-size:14px;margin-top:-5px}", ""]);
	
	// exports
	exports.locals = {
		"main": "_1CGHrDMZ0u",
		"number": "_30t7gr97gF",
		"label": "_1sbH9SaSiG"
	};

/***/ }),

/***/ 965:
/***/ (function(module, exports) {

	(function() {
	
	  (typeof exports !== "undefined" && exports !== null ? exports : this).numberFormat = function(number, decimals, dec_point, thousands_sep) {
	    var decimal, decimalPoint, negative;
	    if (decimals == null) decimals = 0;
	    if (dec_point == null) dec_point = '.';
	    if (thousands_sep == null) thousands_sep = ',';
	    negative = number < 0 ? '-' : '';
	    number = Math.abs(number);
	    decimal = ((number - parseInt(number)).toFixed(decimals)).slice(2);
	    number = ("" + (parseInt(number.toFixed(decimals)))).split('').reverse().join('').replace(/...(?!$)/g, "$&" + (thousands_sep.replace(/\$/g, '$$$$'))).split('').reverse().join('');
	    decimalPoint = decimals !== 0 ? dec_point : '';
	    return "" + negative + number + decimalPoint + decimal;
	  };
	
	}).call(this);


/***/ })

});


// WEBPACK FOOTER //
// 20.uk.20-97fa89369202f8418ef0-built.js